// -----------新-------------
const aaa = [
    {
          path: "yujingList",
          component: () => import("@/views/caigouNew/yujing/yujingList.vue"),
          meta:{title:'临期商品'},
      },
    ];
    export default aaa;
    